import axios from "axios";
import { getEnvironment } from "@sunrun/sales-experience-shared";
import { getAuthToken } from "utils/authUtils";

type HQSEligibility = {
  isEligible: boolean;
};

type getHQSEligibilityInputs = {
  proposalId?: string;
  opportunityId?: string;
};

const toolboxApiUrl =
  getEnvironment() === "production"
    ? "https://designtools.sunrun.com/api"
    : "https://devdesigntools.sunrun.com/api";

const getHQSEligibility = async (
  variables: getHQSEligibilityInputs
): Promise<boolean> => {
  const token = await getAuthToken();
  const response = await axios.post<HQSEligibility>(
    `${toolboxApiUrl}/v1/rules/hqs-eligibility`,
    {
      opportunityId: variables.opportunityId,
      proposalName: variables.proposalId,
    },
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      },
    }
  );

  return response.data?.isEligible;
};

export { getHQSEligibility };
export type { HQSEligibility };
